import axios from "axios";
import { BACKEND_URL } from "../utils/constants";
import {
  Branch,
  GetPartnerQuery,
  GetProductQuery,
  Partner,
  Product,
} from "../dto/commons";

export const getBranches = () =>
  axios.get<Branch[]>(`${BACKEND_URL}/branches`).then((res) => res.data);

export const getPartners = async (query: GetPartnerQuery) => {
  const searchParams = new URLSearchParams();
  searchParams.set("type", query.type);

  return axios
    .get<
      Partner[]
    >(`${BACKEND_URL}/resources/partners?${searchParams.toString()}`)
    .then((res) => res.data);
};

export const getProducts = async (query: GetProductQuery) => {
  return axios
    .get<Product[]>(`${BACKEND_URL}/resources/products`, {
      params: {
        ...query,
      },
    })
    .then((res) => res.data);
};
